import { ActionDto, ApiDataItemDto } from './Action.dto';
import { ActionTypeEnum } from '@/Domain/enum/ActionType.enum';

export type ConnectRemoteMcpDto = {
  remote_mcp_url: string;
  headers?: ApiDataItemDto[];
  // Optional metadata from a catalog pick, carried into the create payload.
  name?: string;
  description?: string;
  icon?: string;
  icon_color?: string;
};

export type RemoteMcpToolNames = {
  tool_names: string[];
};

/** Response of the connect endpoint: tool_names when reachable, or requires_oauth
 * with the discovered provider details when the server needs OAuth. */
export type RemoteMcpConnectResult = {
  tool_names: string[];
  requires_oauth: boolean;
  authorization_server: string | null;
  resource: string | null;
  provider_label: string | null;
};

export const isRemoteMcpOAuthRequired = (result: RemoteMcpConnectResult): boolean =>
  result.requires_oauth === true;

export type RemoteMcpOAuthStatus = {
  status: 'needs_authorization' | 'finalizing' | 'authorized' | 'error';
  provider_label: string;
};

export type RemoteMcpOAuthStartDto = {
  action_id: number;
};

export type RemoteMcpOAuthStartResult = {
  authorization_url: string;
  provider_label: string;
};

export type RemoteMcpOAuthResultMessage = {
  type: 'remote_mcp_oauth_result';
  status: 'success' | 'error';
  action_id: number | null;
  state: string | null;
  reason_code?: string;
};

export type RemoteMcpTool = {
  name: string;
  is_active: boolean;
  // Optional per-tool override for the widget "thinking" message; null/absent -> derived from name.
  thinking_message?: string | null;
};

export type RemoteMcpCreateDto = ConnectRemoteMcpDto & {
  allowed_tools: RemoteMcpTool[];
};

export type RemoteMcpDto = ActionDto & {
  type: ActionTypeEnum.RemoteMcp;
  remote_mcp_url: string;
  remote_mcp_auth_token: string;
  default_tool_is_active: boolean;
  headers: ApiDataItemDto[];
  allowed_tools: RemoteMcpTool[];
  oauth?: RemoteMcpOAuthStatus | null;
};

export type RemoteMcpUpdateDto = {
  id: number;
  remote_mcp_url?: string;
  headers?: ApiDataItemDto[];
  default_tool_is_active?: boolean;
  allowed_tools?: RemoteMcpTool[];
  name?: string;
  description?: string;
  clear_oauth_credentials?: boolean;
};
